<template>
   <div style="z-index: 100000; position: relative" class="bg-light pt-3 pt-lg-5">
      <b-container fluid>
         <b-row class="chat-container">
            <b-col cols="12" lg="3" xl="2" class="p-0">
               <DashUserNav></DashUserNav>
            </b-col>
            <b-col cols="12" lg="9" xl="10" class="pl-3 pl-lg-3 mt-3">
               <h5 class="title-page"><i class="el-icon-chat-line-round"></i> Chat
                  <el-button
                     size="mini"
                     class="font-weight-bold px-2 py-1 font-size-sm ml-3"
                     @click="() => filteredUnansweredChats ? clearFilterConversations() : filterConversations()"
                  >
                     {{filteredUnansweredChats ? 'Ver todos os chats' : 'Ver chats não respondidos'}}
                  </el-button>
               </h5>
               <b-row no-gutters>
                  <b-col cols="12" lg="5" xl="7" class="mt-2 chat-pre-wrap">
                     <el-collapse
                        class="chat-wrap"
                        v-model="activeNames"
                        accordion
                     >
                        <el-collapse-item
                           class="title-chat"
                           v-for="(item, index) in conversations"
                           :key="item.id"
                           :title="`${item.name} (${item.conversation.length})`"
                           :name="item.id">
                           <div v-if="item.conversation.length">
                              <ul>
                                 <li class="px-0 d-flex justify-content-between align-items-center" v-for="conversation in conversations[index].conversation" :key="conversation.id">
                                    <el-button
                                    :style="{ background: conversation._id === conversationID ? 'linear-gradient(90deg, rgba(250,253,99,0.8337710084033614) 0%, rgba(250,253,99,0) 90%)' : '' }"
                                    type="text"
                                    size="mini"
                                    class="font-weight-bold px-4"
                                    @click="openChat(conversation._id)"
                                 >
                                    {{conversation.ref.name}}
                                 </el-button>
                                    <div class="pr-4">
                                       <el-tag size="mini" type="danger" v-if="!wasAnswered(conversation.interactions)">Pendente</el-tag>
                                       <el-tag size="mini" type="info" v-if="wasAnswered(conversation.interactions)">Respondido</el-tag>
                                       </div>
                                 </li>
                              </ul>
                           </div>
                        </el-collapse-item>
                        <p class="pl-4 mt-4" v-if="filteredUnansweredChats && !conversations.length">Parabéns, todos os chats foram respondidos!</p>
                     </el-collapse>
                  </b-col>

                  <b-col v-if="openChatContainer" :class="conversationID ? 'open-chat' : ''" cols="12" lg="7" xl="5" class="chat-pedale-container">
                     <div class="chat-pedale">
                        <el-button
                           size="mini"
                           class="btn-fechar-chat d-block d-lg-none"
                           @click="() => closeChat()"
                        >
                           <v-icon  name="times"></v-icon>
                        </el-button>
                        <ChatContainer
                           showHeader
                           class="h-100 chat-component-wrap"
                           userId="616b18c6422ee13d98a4cb0c"
                           :open="true"
                           :conversationID="conversationID"
                           namespace="conversations"
                           @onMessageSent="() => handleMessageSent()"
                        ></ChatContainer>
                     </div>
                  </b-col>
               </b-row>
            </b-col>
         </b-row>
      </b-container>

   </div>
</template>

<script>
import DashUserNav from "../../../components/DashUserNav"
import ChatContainer from "../../../components/Chat"
import ConversationsService from "../../../services/conversations"

export default {
   name: 'Conversations',
   components: {
      DashUserNav,
      ChatContainer
   },
   data() {
      return {
         bookObj: {
            _id: '6236417d2003f397e871d320',
            orderN: 12,
            owner: {
               _id: "61831a5eb2d3a09c21623e97",
               firstName: "João",
               lastName: "Carlos",
               email: "empresa1@pedale.net.br",
               cpf: "15099273000102",
               resources: {
                  type: "pj"
               },
            },
            customer: {
               _id: "616b18c6422ee13d98a4cb0c",
               firstName: "Élisson",
               lastName: "Kario",
               email: "elisson.kario@gmail.com",
               phone: "(32) 99918-5143",
               cpf: "04450521986"
            },
         },
         activeNames: '',
         loading: {
            chats: false
         },
         user: {},
         conversations: [],
         interaction: {
            _id: "",
            ref: "",
            recipient: "",
            sender: "",
            interactions: []
         },
         conversationID: '',
         sender: null,
         intervalId: null,
         filteredUnansweredChats: false,
         openChatContainer: false
      }
   },
   async mounted() {
      await this.getConversation()
      this.intervalId = setInterval(this.getConversation, 30000);
   },
   beforeDestroy() {
      // Limpa o intervalo quando o componente for desmontado
      clearInterval(this.intervalId);
   },
   methods: {
      /*playSound() {
         const audio = new Audio(`${process.env.VUE_APP_BASE_URL}/static/bicycle.mp3`);
         audio.play();
      },*/

      openChat(id) {
         this.openChatContainer = true
         this.conversationID = id
      },

      wasAnswered(conversations) {
         const lastItem = conversations[conversations.length - 1]
         return lastItem.sender === this.currentUser.user._id;
      },

      async getConversation() {
         try {

            const res = await ConversationsService.getConversations()
            if (res) {
               const conversations = []
               Object.keys(res).map((key) => {
                  let payload = {
                     id: null,
                     name: '',
                  }
                  const conversation = res[key]
                  const title = key.split('#')
                  payload.conversation = conversation
                  payload.id = title[0]
                  payload.name = title[1]
                  conversations.push(payload)
               })

               if (this.filteredUnansweredChats) {
                  this.filterConversations(conversations)
               } else {
                  this.conversations = conversations
               }
            }

         } catch (e) {
            this.$message({
               message: 'Algo deu errado. Tente novamente mais tarde.',
               type: 'error'
            });
         }
      },

      async closeChat(){
         this.openChatContainer = false
        await this.getConversation()
        this.conversationID = ''
     },

      filterConversations(data) {
         const payload = data || this.conversations
         this.conversations = payload.filter(item => {
            return item.conversation.some(f => f.lastInteraction.sender !== this.currentUser.user._id)
         })
         this.filteredUnansweredChats = true
      },

      async clearFilterConversations() {
         this.filteredUnansweredChats = false
         await this.getConversation()
      },

      handleMessageSent(){
         this.getConversation()
         if (this.filteredUnansweredChats) {
            this.filterConversations()
         }
      }

   },

   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
   },

   watch: {}
};
</script>

<style lang="scss">

.title-chat {
   max-width: 100%;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   display: block;
}

/* width */
::-webkit-scrollbar {
   width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
   background: #e0e0e0;
}

/* Handle */
::-webkit-scrollbar-thumb {
   background: #b9b9b9;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
   background: #9b9b9b;
}

.btn-fechar-chat {
   position: absolute;
   z-index: 1000000;
   margin-left: auto;
   text-align: center;
   top: 9px;
   right: 12px;
   padding: 5px 11px;

   svg {
      margin-top: -3px;
      color: #47b54c
   }
}

   .dashboard.chat {
      #footer {
         display: none;
         padding: 0 !important;
         .wrap.container {
            display: none;
         }
         .copyright {
            margin: 0;
         }
      }
      .title-page {
         background: #fff;
         color: #47b54c;
         width: 100%;
         padding: 10px 20px;
         margin-top: -9px;
         margin-bottom: -9px;
      }
      .chat-pedale {
         width: 100% !important;
         z-index: 100;
         position: relative;
         margin-top: -35px;
         height: 72vh;
         margin-left: auto;


         .chat-component-wrap {
            overflow: hidden;

            .el-drawer__header {
               position: absolute;
               z-index: 100000;
               right: 0;
               left: 0;
            }

            &.chat-header {
               display: flex;
               flex-direction: column;
               height: 100% !important;
               justify-content: center;

               .chat-header-wrap {
                  margin-top: -70px;
               }
            }
         }

         #target {
            padding-bottom: 120px;
            padding-top: 60px;
         }

         .input-text-chat textarea {
            padding-right: 50px;
            border: 0 !important;
         }

         .upload-file-chat {
            transform: scale(0.8);
            bottom: 50px;
            right: 31%;
         }

        .form-chat {
           padding: 15px 18px;
        }

         .btn-chat {
            height: 65px;
         }
      }

      .chat-container {

      }
   }

@media screen and (max-width: 992px) {
   .dashboard .chat-pedale-container {
      transition: all 300ms ease;
      right: -1000px;
      position: fixed;
      &.open-chat {
         right: 0;
      }
   }
   .dashboard .chat-pedale {
      margin-top: -101px !important;
      height: 100vh !important;
   }
   .dashboard .chat-pre-wrap {
      max-height: 75vh;
   }
}



.chat-wrap {
   height: 64.2vh;
    overflow: auto;
    min-height: 100%;

      @media screen and (max-width: 992px) {
         max-height: 80vh;
         height: auto;
      }


    &.el-collapse {
       background: #fff;
    }

    .el-collapse {
       border-top: 0;
       border-bottom: 0;
    }

    .el-collapse-item {
       @media screen and (max-width: 992px) {

       }
    }

    .el-collapse-item__header {
       padding-left: 20px;
       font-weight: bold;
    }

    .el-collapse-item__content {
      padding-bottom: 0;
    }

    ul {
       list-style: none;
       padding-left: 0;
       margin-bottom: -1px;

       li {
          &:first-child {
             border-top: 1px solid #ebeef5;
          }

          &:last-child {

          }
          border-bottom: 1px solid #ebeef5;
          padding: 0 20px;

          .el-button {
             text-align: left;
             line-height: 30px;
             width: 100%;
             span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 100%;
                display: block;
             }
          }
       }
    }
 }
</style>
